import { Fragment } from "react";
import { CustomPagination } from "@store/action/GlobalAction";
import TopicsCards from "../TopicsCards";
import NewsHeader from "../NewsHeader";

const NewsPage = (props) => {
  const { activeView, setActiveView, store, setCurrentPage, t } = props;
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };

  return (
    <div>
        <NewsHeader activeView={activeView} setActiveView={setActiveView} />
        {store.topic_by_user?.data?.length ? (
          <Fragment>
            <TopicsCards t={t} news={store.topic_by_user} activeView={activeView} />
            <div className="d-flex justify-content-center">
              {CustomPagination(store.total, 5, handlePageChange)}
            </div>
          </Fragment>
        ) : (
          <div className="d-flex justify-content-center mt-2">
            <p>{t("No Results")}</p>
          </div>
        )}
    </div>
  );
};

export default NewsPage;
